var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0449 4.1922V2.5961C10.0449 2.17279 9.90476 1.76681 9.65531 1.46749C9.40586 1.16816 9.06754 1 8.71476 1H2.33013C1.97736 1 1.63903 1.16816 1.38959 1.46749C1.14014 1.76681 1 2.17279 1 2.5961V12.1727C1 12.596 1.14014 13.002 1.38959 13.3013C1.63903 13.6006 1.97736 13.7688 2.33013 13.7688H8.71476C9.06754 13.7688 9.40586 13.6006 9.65531 13.3013C9.90476 13.002 10.0449 12.596 10.0449 12.1727V10.5766",
    stroke: "#1D1D1D",
    strokeWidth: 1.06589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1738 4.19214L14.8345 7.38479L12.1738 10.5775",
    stroke: "#1D1D1D",
    strokeWidth: 1.06589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75635 7.38403H14.8345",
    stroke: "#1D1D1D",
    strokeWidth: 1.06589,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.e61c941e063009382da3cda626aa396c.svg";
export { ForwardRef as ReactComponent };